/* eslint-disable import/prefer-default-export */
import { useMutation } from '@apollo/client/react';
import { AddNotification, AddMinimalNotification } from 'graphqlDocuments/mutations';
import { useTranslation } from 'react-i18next';
import { findFirstGraphQLError } from 'utils/graphql';

export const useToast = () => {
  const { t } = useTranslation(['LAYOUT', 'STATIC']);
  const [addNotification] = useMutation(AddNotification);
  const [addMinimalNotification] = useMutation(AddMinimalNotification);

  const notificationFromErr = (error) => {
    const graphQLError = findFirstGraphQLError(error);
    const { code, errorNumber, response } = graphQLError?.extensions || error;
    const errorMessage = graphQLError?.message || error.message;
    const translationOptions = { defaultValue: errorMessage, ...response?.body?.data };

    return {
      autoClose: true,
      errorCode: errorNumber,
      message: t([`ERRORS:${code}`, errorMessage], translationOptions),
      title: t([`ERRORS:${code}_TITLE`, 'ERRORS:SOMETHING_WENT_WRONG']),
      type: 'error',
    };
  };

  const toast = (notification) => {
    addNotification({ variables: { notification } });
  };

  const toastMinimal = (notification) => {
    addMinimalNotification({ variables: { notification } });
  };

  const toastErr = (error) => {
    const notification = notificationFromErr(error);
    toast(notification);
  };

  return { toast, toastMinimal, toastErr };
};
